import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Navigation } from './Navigation';
import './markdown.less';

import { HistoricalProgress } from '@components/HistoricalProgress';
import { MarkdownWrapper } from '@components/MarkdownWrapper';
import { Divider, Link } from '@heroui/react';
import { IoAtOutline, IoLogoFacebook } from 'react-icons/io5';
import about from './content/about.md';
import board from './content/board.md';
import contribute from './content/contribute.md';
import property1 from './content/img/photo/property1.jpg';
import property2 from './content/img/photo/property2.jpg';
import property3 from './content/img/photo/property3.jpg';
import property4 from './content/img/photo/property4.jpg';
import property5 from './content/img/photo/property5.jpg';
import property6 from './content/img/photo/property6.jpg';
import news from './content/news.md';
import alleyway from './content/projects/alleyway.md';
import blockParty from './content/projects/block-party.md';
import { HistoricalStatus } from './content/projects/historical/HistoricalStatus';
import historical from './content/projects/historical/historical.md';
import median from './content/projects/median.md';
import medianDetails from './content/projects/median-details.md';
import repaving from './content/projects/repaving.md';
import traffic from './content/projects/traffic.md';
import { ImageCarousel } from './ImageCarousel';
import Providers from './Providers';

export function App() {
  const images = [property1, property2, property3, property4, property5, property6];

  return (
    <BrowserRouter>
      <Providers>
        <Navigation />
        <main className="bg-container mx-auto w-full max-w-4xl px-2 grow">
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <div className="flex flex-col mt-4 w-full items-center gap-2">
                    <h1>Windsor Park Community</h1>
                  </div>
                  <ImageCarousel images={images} />
                  <Divider className="my-8" />
                  {/* <HistoricalProgress />
                  <Divider className="my-8" /> */}
                  <MarkdownWrapper title="Home" className="md centerimages">
                    {news}
                  </MarkdownWrapper>
                </>
              }
            />
            <Route
              path="/about"
              element={
                <>
                  <div className="flex flex-col mt-4 w-full items-center gap-2">
                    <h1>Windsor Park Community</h1>
                  </div>
                  <MarkdownWrapper
                    title="About"
                    className="md"
                    components={{
                      a({ href, children }) {
                        return (
                          <Link target="_blank" href={href}>
                            {children}
                          </Link>
                        );
                      },
                    }}
                  >
                    {about}
                  </MarkdownWrapper>
                </>
              }
            />
            <Route
              path="/board"
              element={
                <MarkdownWrapper className="bod" title="Board of Directors">
                  {board}
                </MarkdownWrapper>
              }
            />
            <Route
              path="/projects/historical-status"
              element={
                <>
                  <div className="flex flex-col mt-4 w-full items-center gap-2">
                    <h1>Windsor Park Community</h1>
                  </div>
                  <HistoricalProgress />
                  <Divider className="my-8" />
                  <MarkdownWrapper title="Historical Status" className="md">
                    {historical}
                  </MarkdownWrapper>
                </>
              }
            />
            <Route path="/projects/historical-status/lookup" element={<HistoricalStatus />} />
            <Route
              path="/projects/alleyway-cleanup"
              element={
                <MarkdownWrapper title="Alleyway Cleanup" className="md">
                  {alleyway}
                </MarkdownWrapper>
              }
            />
            <Route
              path="/projects/desert-garden-median"
              element={
                <MarkdownWrapper title="Desert Garden Median" className="md">
                  {median}
                </MarkdownWrapper>
              }
            />
            <Route
              path="/projects/desert-garden-median/details"
              element={
                <MarkdownWrapper title="Desert Garden Median" className="md">
                  {medianDetails}
                </MarkdownWrapper>
              }
            />
            <Route
              path="/projects/block-party"
              element={
                <MarkdownWrapper title="Block Party" className="md blockparty">
                  {blockParty}
                </MarkdownWrapper>
              }
            />
            <Route
              path="/projects/traffic"
              element={
                <MarkdownWrapper title="Speed Mitigation on N Camino Seco" className="md">
                  {traffic}
                </MarkdownWrapper>
              }
            />
            <Route
              path="/projects/repaving"
              element={
                <MarkdownWrapper title="Road Repaving" className="md">
                  {repaving}
                </MarkdownWrapper>
              }
            />
            <Route
              path="/contribute"
              element={
                <MarkdownWrapper
                  title="Contribute"
                  className="md"
                  components={{
                    a({ href, children }) {
                      return (
                        <Link target="_blank" href={href}>
                          {children}
                        </Link>
                      );
                    },
                  }}
                >
                  {contribute}
                </MarkdownWrapper>
              }
            />
          </Routes>
        </main>
        <footer className="bg-footer px-2 w-full h-12 mt-8 flex justify-center">
          <div className="w-full max-w-4xl flex justify-between items-center">
            <div className="text-white">© 2025 Windsor Park Community</div>
            <div className="text-white flex gap-2 items-baseline">
              <Link href="https://www.facebook.com/groups/920896984953364/" target="_blank" className="text-white">
                <IoLogoFacebook size={24} />
              </Link>
              <Link href="mailto:andrew@windsorparkcommunity.org" className="text-white">
                <IoAtOutline size={24} />
              </Link>
            </div>
          </div>
        </footer>
      </Providers>
    </BrowserRouter>
  );
}
